import { CommonModule, DecimalPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { ProductionKeyPerformanceIndicatorEvaluation } from 'src/app/models/production-key-performance-indicator-evaluation.model';
import { CompanyProductExpectedVsRegisteredWorkGeneralKpiDetail } from 'src/app/models/company-product-expected-vs-registered-work-kpi-data.model';

@Component({
  selector: 'app-company-product-expected-vs-registered-work-details',
  imports: [CommonModule, DecimalPipe],
  templateUrl: './company-product-expected-vs-registered-work-details.component.html',
  styleUrl: './company-product-expected-vs-registered-work-details.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CompanyProductExpectedVsRegisteredWorkDetailsComponent {
  currentMonthEvaluation = input<ProductionKeyPerformanceIndicatorEvaluation | null>(null);

  detailData = computed((): CompanyProductExpectedVsRegisteredWorkGeneralKpiDetail | null => {
    const raw = this.currentMonthEvaluation()?.data;
    return CompanyProductExpectedVsRegisteredWorkDetailsComponent.isCompanyProductExpectedVsRegisteredWorkGeneralKpiDetail(raw)
      ? raw
      : null;
  });

  summary = computed((): { expected: number; done: number; compliance: number; deviation: number } | null => {
    const detail = this.detailData();
    if (detail === null) {
      return null;
    }

    return {
      expected: detail.expected_hours,
      done: detail.done_hours,
      deviation: detail.deviation_percentage,
      compliance: detail.compliance_percentage,
    };
  });

  private static isCompanyProductExpectedVsRegisteredWorkGeneralKpiDetail(
    value: unknown
  ): value is CompanyProductExpectedVsRegisteredWorkGeneralKpiDetail {
    if (value === null || typeof value !== 'object') {
      return false;
    }

    const candidate = value as Partial<CompanyProductExpectedVsRegisteredWorkGeneralKpiDetail>;

    return (
      typeof candidate.done_hours === 'number' &&
      typeof candidate.expected_hours === 'number' &&
      typeof candidate.deviation_percentage === 'number' &&
      typeof candidate.compliance_percentage === 'number'
    );
  }
}
